export default __webpack_public_path__ + "images/bafddc5087e39d2f7ddbc40180a7099a-rugby_small.webp";